import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AdminDashboardSectionState, AdminDashboardWorkQueues } from "@/types/dashboard";

export type DashboardWorkQueuesState = AdminDashboardSectionState<AdminDashboardWorkQueues>;

export const dashboardWorkQueuesInitialState: DashboardWorkQueuesState = {
  data: null,
  error: null,
};

const slice = createSlice({
  name: "dashboardWorkQueues",
  initialState: dashboardWorkQueuesInitialState,
  reducers: {
    setDashboardWorkQueuesAction(state, { payload }: PayloadAction<AdminDashboardWorkQueues | null>) {
      state.data = payload;
      state.error = null;
    },
    setDashboardWorkQueuesErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload;
    },
  },
});

export const { setDashboardWorkQueuesAction, setDashboardWorkQueuesErrorAction } = slice.actions;
export default slice.reducer;
